import { useCallback, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from '../conf/config';

export const useDeleteAccount = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const deleteAccount = useCallback(async (id: string) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    try {
      const res = await axios.delete(`${ApiUrl}/admin/api/v1/accounts/${id}`, {
        headers: { Authorization: 'Bearer ' + token },
      });
    } catch (e) {
      console.error(e);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteAccount, loading, error };
};
